import React, { useCallback } from "react";

const openOneTrustPreferenceCenter = () => {
  const oneTrust = window.OneTrust || window.Optanon;
  if (oneTrust && typeof oneTrust.ToggleInfoDisplay === "function") {
    oneTrust.ToggleInfoDisplay();
    return true;
  }
  return false;
};

export const CookieConsentButton = () => {
  const handleClick = useCallback((event) => {
    event.preventDefault();
    event.stopPropagation();

    if (openOneTrustPreferenceCenter()) {
      return;
    }

    // OneTrust may still be loading; retry briefly after SDK init.
    let attempts = 0;
    const timer = window.setInterval(() => {
      attempts += 1;
      if (openOneTrustPreferenceCenter() || attempts >= 20) {
        window.clearInterval(timer);
      }
    }, 250);
  }, []);

  return (
    <button
      className="cookie-consent-button"
      tabIndex="0"
      type="button"
      id="payment-portal-cookie-settings"
      onClick={handleClick}
      aria-label="Cookie preferences"
    >
      <span aria-hidden="true">
        <svg
          width="33"
          height="33"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          stroke="#ffffff"
        >
          <path
            d="M9 16H9.01M12 11H12.01M7 10H7.01M15 16H15.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C12 5.76142 13.7909 8 16 8C16 10.2091 18.2386 12 21 12Z"
            stroke="#ffffff"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </span>
    </button>
  );
};

export const PrivacyNoticeLink = ({ className = "" }) => (
  <a
    target="_blank"
    className={`text-sm font-Apercu-Regular text-white whitespace-nowrap ${className}`}
    href="https://www.asurion.com/en-gb/privacy-notice/"
    rel="noreferrer"
  >
    Privacy Notice
  </a>
);

const PrivacyFooter = () => (
  <div className="privacy-footer-bar flex items-center justify-between px-4 py-2">
    <div className="flex flex-shrink-0 items-center">
      <CookieConsentButton />
    </div>
    <PrivacyNoticeLink />
  </div>
);

export default PrivacyFooter;
